import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import { initGA } from "./utils/analytics";
import { AuthProvider } from "./context/AuthContext";
import { store } from "./redux/store";
import { HelmetProvider } from "react-helmet-async";



initGA();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);
